import styled from 'styled-components'
import { themeGet } from 'styled-system'
import ReportTableHeaderTooltip from './component'

export const TableHeaderTooltip = styled(ReportTableHeaderTooltip)`
  white-space: break-spaces;
  margin-left: ${themeGet('spacing.pink8_0_5rem')};

  i {
    color: ${themeGet('colors.blueGray')};
    font-size: 0.875rem;
  }

  ${themeGet('breakpoints.tablet')} {
    margin-left: 0.25rem;
  }
`

const withPosition = positionVariant =>
  styled(TableHeaderTooltip).attrs({ positionVariant })``

export const ClassesTooltip = withPosition('leftOffset')
export const LessonProgressTooltip = withPosition('leftOffset')
export const LastLessonTooltip = withPosition('centered')
export const MarkedDoneTooltip = withPosition('centered')
export const GradeTooltip = withPosition('centered')
